@let controls = form().controls;
<div class="shipping">
  <div class="label-container">
    <p class="f-body-xs f-medium">{{ 'labels.shippingTypes' | translate }}</p>

    <onyx-icon
      class="f-muted"
      name="tooltip-filled"
      [size]="12"
      onyxTooltip="labels.selectOneOption"
    ></onyx-icon>
  </div>

  <div class="container" [formGroup]="form()">
    <div class="item">
      <onyx-toggle label="labels.byEmail" [(checked)]="hasEmails"></onyx-toggle>

      @if (hasEmails()) {
        <div class="emails">
          @for (emailControl of controls.emails.controls; track emailControl) {
            <div class="email">
              <onyx-text-field
                [formControl]="emailControl"
                [size]="32"
                placeholder="labels.email"
                textTransform="lowercase"
                width="330px"
              ></onyx-text-field>

              <onyx-icon-button
                variant="transparent"
                color="gray"
                [size]="32"
                icon="delete-outlined"
                (click)="removeEmail($index)"
              ></onyx-icon-button>

              @if ($last) {
                <div class="separator"></div>

                <onyx-button
                  variant="outlined"
                  [size]="32"
                  (click)="addEmail()"
                >
                  {{ 'labels.add' | translate }}
                </onyx-button>
              }
            </div>
          }
        </div>
      }
    </div>

    <div class="item">
      <onyx-toggle
        class="max-content"
        label="labels.internalPortal"
        [(checked)]="hasInternalPortal"
      ></onyx-toggle>

      @let internalPortalControls = controls.internalPortal.controls;
      @if (hasInternalPortal()) {
        <div class="internal-portal">
          <onyx-text-field
            [formControl]="internalPortalControls.url"
            placeholder="labels.siteUrl"
            [size]="32"
          ></onyx-text-field>

          <onyx-text-field
            [formControl]="internalPortalControls.login"
            placeholder="labels.login"
            [size]="32"
          ></onyx-text-field>

          <onyx-text-field
            [formControl]="internalPortalControls.password"
            placeholder="labels.password"
            [size]="32"
          ></onyx-text-field>
        </div>
      }
    </div>

    <div class="item">
      <onyx-toggle
        class="max-content"
        [formControl]="controls.traditionalMail"
        label="labels.traditionalMail"
      ></onyx-toggle>

      @if (hasTraditionalMail()) {
        <onyx-checkbox
          [formControl]="controls.isOriginalDocumentRequired"
          label="labels.originalDocumentRequired"
        ></onyx-checkbox>
      }
    </div>

    @if (isInvalid()) {
      <div class="error f-danger f-body-xs f-medium">
        <onyx-icon name="error-filled" [size]="12"></onyx-icon>

        {{ 'labels.selectOneOption' | translate }}
      </div>
    }
  </div>
</div>
